import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { languageNames, languageFlags, translations } from '../lib/translations';
import { Globe, Check } from '@phosphor-icons/react';

const languages = ['ITA', 'ENG', 'FRA', 'SPA', 'TED'];

export default function LanguageSelectPage() {
  const [selected, setSelected] = useState('ITA');
  const navigate = useNavigate();

  const t = translations[selected];

  const handleContinue = () => {
    localStorage.setItem('selectedLanguage', selected);
    navigate('/setup-profile');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8">
      <div className="w-full max-w-lg animate-fade-in">
        <div className="flex items-center justify-center mb-8">
          <div className="w-16 h-16 bg-zinc-100 flex items-center justify-center">
            <Globe size={32} weight="bold" className="text-zinc-700" />
          </div>
        </div>

        <h1 className="text-3xl font-black text-center text-zinc-900 tracking-tight mb-2">
          {t.selectLanguage}
        </h1>
        <p className="text-center text-zinc-500 mb-10">
          {t.languageDescription}
        </p>

        <div className="grid gap-3">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => setSelected(lang)}
              className={`w-full p-5 border text-left flex items-center justify-between transition-all ${
                selected === lang
                  ? 'border-zinc-900 bg-zinc-50'
                  : 'border-zinc-200 hover:border-zinc-400'
              }`}
              data-testid={`language-option-${lang.toLowerCase()}`}
            >
              <div className="flex items-center gap-4">
                <span className="text-2xl">{languageFlags[lang]}</span>
                <span className="font-medium text-zinc-900">{languageNames[lang]}</span>
              </div>
              {selected === lang && (
                <Check size={24} weight="bold" className="text-zinc-900" />
              )}
            </button>
          ))}
        </div>

        <Button
          onClick={handleContinue}
          className="w-full mt-8 rounded-none bg-zinc-900 hover:bg-zinc-800 text-white font-bold uppercase tracking-wider py-6"
          data-testid="language-continue-button"
        >
          {t.continue}
        </Button>
      </div>
    </div>
  );
}
